import { useCallback, useEffect, useState } from 'react';
import { ToggleContainer, Label, StyledToggle, Switch } from './style';

type ToggleProps = {
  checked?: boolean;
  label?: string;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  testId: string;
  labelPosition?: 'left' | 'right';
};

export const Toggle = ({
  checked = false,
  label,
  disabled,
  onChange,
  testId,
  labelPosition = 'left',
}: ToggleProps) => {
  const [isChecked, setIsChecked] = useState(checked || false);

  const toggleChecked = useCallback(() => {
    setIsChecked(!isChecked);
    onChange(!isChecked);
  }, [isChecked, onChange]);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <ToggleContainer labelPosition={labelPosition}>
      {label && <Label>{label}</Label>}
      <StyledToggle
        onClick={toggleChecked}
        disabled={disabled}
        checked={isChecked}
        data-testid={testId}
      >
        <Switch checked={isChecked} />
      </StyledToggle>
    </ToggleContainer>
  );
};
